module.exports = __webpack_public_path__ + "static/media/faded-ebony-grey.ad63d7df.jpg";